define(
    "diy/undo-redo/Settings",
    [
        'jquery',
        'diy/undo-redo/constants',
        'diy/util/helper'
    ],
    /**
     * @param {jQuery} $
     * @param {module.undoRedo.constants} constants
     * @param {diy.util.Helper} helper
     */
    function ($, constants, helper) {
        'use strict';

        var Settings;
        /**
         * @class module.undoRedo.Settings
         * @template module.undoRedo.Settings
         * @lends {module.undoRedo.Settings.prototype}
         * @constructor
         */
        Settings = Klazz.extend({

            /** @type {module.undoRedo.FeatureSet} */
            featureSet: null,

            features: [
                {
                    name: constants.features.PAGES,
                    key: '_removeme_undoRedoPages',
                    defaultEnabled: true,
                    defaultValue: 1
                },
                {
                    name: constants.features.LAYOUTS,
                    key: '_removeme_undoRedoLayouts',
                    defaultEnabled: true,
                    defaultValue: 1
                },
                {
                    name: constants.features.DESIGNS,
                    key: '_removeme_undoRedoDesigns',
                    defaultEnabled: true,
                    defaultValue: 1
                }
            ],

            ini: {
                websiteId: '',
                sessionId: '',
                localStorageName: 'undoredo',
                localStorageSize: 5,

                displayLimit: 25,

                localEntriesLimit: 500

            },
            /**
             * Called by plugins / models to get it's own settings from the corresponding section
             *      if the section name is not in the list will throw error
             *
             * @param section {String}
             * @returns {*}
             */
            get: function (section) {
                if (typeof this.ini[section] !== 'undefined') {
                    return this.ini[section];
                } else {
                    throw 'settings:ini: undefined section ' + section;
                }
            },
            getIni: function() {
                return this.ini;
            },

            /**
             *
             * @returns {Array.<Object>}
             */
            getFeatures: function getFeatures() {
                return this.features;
            },
            /**
             * @constructs
             */
            /**
             *
             * @param {module.undoRedo.FeatureSet} featureSet
             */
            initialize: function (featureSet) {
                this.featureSet = featureSet;
            },

            init: function () {
                this.ini.websiteId = helper.getWebsiteId();
                this.ini.sessionId = helper.getSessionName();
            }
        });
        return Settings;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/Settings.js
 ** module id = 888
 ** module chunks = 0
 **/